<p-galleria
  ngSkipHydration
  [showIndicators]="false"
  [value]="photos()"
  [(activeIndex)]="activeIndexSignal"
  [showIndicatorsOnItem]="'inside'"
  [circular]="true"
  [showItemNavigators]="true"
  [showThumbnails]="false"
  [showThumbnailNavigators]="false"
  [shouldStopAutoplayByClick]="true"
  class="block mb-8 slight-overflow-x relative"
>
  <ng-template #item let-item>
    <div class="relative rounded-lg thin:h-[300px] h-[340px] w-full">
      @if (item.last === true) {
        <img fetchpriority="high"
             [homeyImage]="'header'"
             [homeyImageSrc]="photos()[0].baseImage"
             [alt]="photos()[0].alt"
             class="block  w-full h-full max-h-full absolute object-cover object-bottom brightness-50 top-0 left-0 right-0 bottom-0"
        />
        <a pButton
           class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
           [routerLink]="initialSignupRouteIncludingInfo"
           [queryParams]="{ lotteryName: apartment().name }"
><span pButtonLabel>Check eligibility</span></a>
      } @else {
       <button
         type="button"
         class="absolute z-[10] left-0 right-0 top-0 bottom-0 flex items-center justify-center cursor-pointer bg-transparent transition-colors zoom-trigger group hoverable:hover:bg-black/50 hoverable:focus-visible:bg-black/50 focus:outline-none"
         (click)="openGallery()">
         <i class="pi pi-search-plus text-white relative hidden opacity-0 hoverable:transition-opacity hoverable:group-hover:opacity-100 hoverable:group-focus-visible:opacity-100" style="font-size: 4rem"></i>
       </button>
       <img fetchpriority="high"
            [homeyImage]="'header'"
            [homeyImageSrc]="item.baseImage"
            [alt]="item.alt"
            class="block w-full h-full max-h-full object-cover object-bottom top-0 left-0 right-0 bottom-0"
       />
     }
    </div>
  </ng-template>

  <ng-template #footer let-item>
    @if (canShare()) {
        <p-button
          (onClick)="onShare()"
          class="absolute top-2 right-2 z-10"
          size="small"
          icon="pi pi-share-alt"
          severity="secondary"
          label="Share"
        ></p-button>
    }
    <div class="absolute bg-[--p-galleria-inset-indicator-list-background] rounded-xl px-2 text-xs bottom-2 right-2" style="color: white">
      <span>{{ activeIndexSignal() + 1 }}/{{ photos().length }}</span>
    </div>
  </ng-template>
</p-galleria>

  <p-galleria
    ngSkipHydration
    [value]="photos()"
    [(activeIndex)]="activeIndexSignal"
    [showIndicators]="false"
    [showIndicatorsOnItem]="'inside'"
    [circular]="true"
    [showItemNavigators]="true"
    [showThumbnails]="false"
    [showThumbnailNavigators]="false"
    [fullScreen]="true"
    [(visible)]="modalOpen"
    [shouldStopAutoplayByClick]="true"
    class="block mb-8 slight-overflow-x relative"
  >
    <ng-template #item let-item>
      <div class="relative">
        <div
          class="absolute inset-0 z-0 flex items-center justify-center bg-surface-900/30 pointer-events-none min-h-8 min-w-8"
        >
          <p-progressSpinner strokeWidth="4" />
        </div>
        @if (item.last === true) {
            <img fetchpriority="high"
                 [homeyImage]="'full'"
                 [homeyImageSrc]="photos()[0].baseImage"
                 [alt]="photos()[0].alt"
                 class="relative block h-full max-h-full brightness-50 top-0 -translate-x-0.5 left-0.5"
            />
            <div class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
              <a pButton><span pButtonLabel>Check eligibility</span></a>
            </div>
        } @else {
          <img fetchpriority="high"
               [homeyImage]="'full'"
               [homeyImageSrc]="item.baseImage"
               [alt]="item.alt"
               class="relative block w-full m-auto h-full max-h-full top-0 left-0 right-0 bottom-0"
          />
        }
      </div>
    </ng-template>
  </p-galleria>
<div class="mb-8">
  <homey-page-title
    [title]="apartment().name"
    [marginStyle]="'none'"
    [atPageTop]="false"
  />

  @if (showH2()) {
    <h2 class="text-lg mb-2 font-medium">
      Affordable Housing Connect Lottery
    </h2>
  }

  <p class="text font-medium mb-1">{{ apartment() | apartmentAddress }}</p>

  <ng-content select="[trackingBanner]"></ng-content>
</div>

<div class="block mb-6 font-medium text-surface-600 border rounded-xl border-surface-200 py-5 px-8 empty:hidden">
  <ng-content/>
</div>

<ng-content select="[apartmentUnits]"></ng-content>

@let apartmentValue = apartment();
@if (apartmentValue.type !== 'senior' && (apartmentValue.unitTypes | minRent) !== 0) {
  @let min = apartmentValue.unitTypes | estimatedSavings | min;
  @let max = apartmentValue.unitTypes | estimatedSavings | max;
  <homey-apartment-detail-info-item
    icon="pi-dollar"
    title="Estimated savings"
  >
    @if (min === max) {
      <p>{{ min | toNearestDecimal | dollar }} / month</p>
    } @else {
      <p>{{ min | toNearestDecimal | dollar }} – {{ max | toNearestDecimal | dollar }} / month</p>
    }
  </homey-apartment-detail-info-item>
}

  <homey-apartment-detail-info-item
    icon="pi-stopwatch"
    title="Timeline"
  >
  <p>
    @if (apartment().status === 'open') {
      @let state = timelineState();
      @if (state.type === 'today') {
        Lottery closes <strong>today</strong>.
      } @else if (state.type === 'time') {
        Lottery closes in
        <strong>
          @if (state.lessThanHour) {
            less than 1 hour
          } @else {
            @if (state.days > 0) {
              {{ state.days }} {{ state.days === 1 ? 'day' : 'days' }}
            }
            @if (state.includeHours && state.hours > 0) {
              @if (state.days > 0) {, }
              {{ state.hours }} {{ state.hours === 1 ? 'hour' : 'hours' }}
            }
          }
        </strong>.
      } @else {
        Lottery closed on {{ apartment().endDate | date:'MMM d' }}
      }
    } @else {
      Lottery closed on {{ apartment().endDate | date:'MMM d' }}
    }
  </p>
  @if (apartment().status === 'closed') {
    <p>
    @if (!drawingDateInPast()) {
      Lottery drawing expected by {{ drawingDate() | date:'MMM d' }}
    }
  </p>
  }
</homey-apartment-detail-info-item>

<ng-container>
  <ng-content select="[otherBlocks]"></ng-content>
</ng-container>

<div class="overflow-ellipsis">
  <div
    class="mb-1 lottery-description"
    [ngClass]="{ 'max-7-lines': !showAllDescription }"
    [innerHTML]="description()"
  ></div>

  <button
    class="underline"
    (click)="toggleShowMore()"
  >
    {{ showAllDescription ? 'Show less' : 'Show more' }}
  </button>
</div>

<p-divider/>

@if (apartment().amenities.length > 0) {
  <homey-page-subtitle
    title="What this place offers"
  />

  @let maxAmenities = 8;
  <ng-container>
    <ul class="mb-6 flex flex-col gap-2">
      @for (amenity of apartment().amenities | slice:0:(showAllAmenities ? apartment().amenities.length : maxAmenities); track amenity) {
        @let label = amenity | amenityLabel;
        @if (label) {
          <li class="flex flex-row gap-2">
            <span class="material-symbols-outlined">{{ amenity | amenityIcon }}</span>
            <!-- If amenityLabel pipe already localizes, keep as-is; otherwise wrap in Transloco: -->
            <span>{{ label }}</span>
          </li>
        }
      }
    </ul>
  </ng-container>

  @if (apartment().amenities.length > maxAmenities) {
    <p-button styleClass="w-full" [outlined]="true" severity="contrast" (onClick)="toggleShowAmenities()"     [autofocus]="false">
      {{ showAllAmenities ? 'Show less' : ('Show all ' + apartment().amenities.length + ' amenities') }}
    </p-button>
  }

  <p-divider/>
}

<homey-page-subtitle
  title="Where you'll live"
/>
<p class="mb-2">{{ apartment() | apartmentAddress }}</p>

@let url = 'https://www.google.com/maps/embed/v1/place?key=AIzaSyCVlXJPEO58xDgs6wEPFyInRIEoqRyYDeo&q=' + apartment().addressInfo.latitude + ',' + apartment().addressInfo.longitude;
@let safeUrl = url | safe;
<iframe
  class="w-full"
  height="300"
  style="border:0"
  loading="lazy"
  allowfullscreen
  referrerpolicy="no-referrer-when-downgrade"
  [src]="safeUrl"
></iframe>
